import apiRequest from '@/http/api-request'
import authService from "@/auth/authService";
import {prepareDonorsArray} from "@/utils/donors";

export default {
  createProxyToken(tmp, {userId}) {
    return apiRequest.doPostRequest(`/client/proxy/${userId}`)
  },
  fetchAllDonors({commit, state}, {charityId, force = false}) {

    if (state.donorsState === 'loading') {
      return new Promise((resolve) => resolve(state.donors));
    }

    if (state.donorsState === 'ready' && force !== true
      && (parseInt((new Date().getTime() / 1000)) - state.lastUpdate) < 60 * 14 //14 min cache
    ) {
      return new Promise((resolve) => resolve(state.donors));
    }

    commit('LOADING_DONORS');

    return new Promise((resolve, reject) => {
      return apiRequest.doGetRequest('/data/donor/breakdown/emails',
        {
          charity_id: charityId,
          jwt: authService.getToken(),
        },
        {},
        {skipCache: true, resCallback: (res) => prepareDonorsArray(res)})
        .then(donors => {
          commit('SET_DONORS', donors);
          resolve(donors);
        })
        .catch((error) => reject(error));
    });
  },
  fetchGenders({commit, state}) {

    if ((parseInt((new Date().getTime() / 1000)) - state.gendersLastUpdate) < 60 * 60* 24 //1 day cache
    ) {
      return new Promise((resolve) => resolve(state.genders));
    }

    return new Promise((resolve, reject) => {
      return apiRequest.doGetRequest(`/account/genders`)
        .then(genders => {
          commit('SET_GENDERS', genders);
          resolve(genders);
        })
        .catch((error) => reject(error));
    });
  },
}
